import React, { useState, useEffect, useRef } from 'react'
import { connect } from 'react-redux'
import DatePicker from 'react-datepicker'
import useIsMobile from '../../../hooks/useIsMobile'
import { Section, SectionHeader, SectionTitle } from '../../../styled/sections'
import { Button } from '../../../components/ui/button'
import ResultsListDesk from '../../../components/resultsListDesk'
import ResultsList from '../../../components/resultCard'
import { getDuties, downloadDutiesAsFile } from '../../../api'
import { selectLabsFilters, selectLabsFiltersCount } from '../../../reducers/filterLaboratory'
import Pagination from '../../../components/pagination'
import { FormContainer } from '../../../components/ui/form'
import Input from '../../../components/ui/input'
import { Formik } from 'formik'
import { ArrowDouble, Calendar, Download, SadFace } from '../../../assets/icons'
import 'react-datepicker/dist/react-datepicker.css'
import { CalendarBlock } from '../Appointments/selectAppointment/SelectAppointment'
import { IconContainer } from '../../../components/quickAceesCard/styled'
import { Text1, Text2 } from '../../../components/ui/text'
import theme from '../../../styled/theme'
import { Container } from '../../../components/homeDashBoard/styled'
import to from 'await-catch'
import moment from 'moment'
import EmptyState from '../../../components/emptyState'

function Arancels({ auth }) {
	const isMobile = useIsMobile()

	const [selectedDate, setSelectedDate] = useState(new Date())
	const [showCalendar, setShowCalendar] = useState(false)
	const [resultsLst, setResultsLst] = useState([])
	const [totalPages, setTotalPages] = useState(1)
	const [currentPage, setCurrentPage] = useState(1)
	const [loading, setLoading] = useState(false)
	const [searchWasMade, setSearchWasMade] = useState(false)
	const inFlightRequestKeyRef = useRef(null)
	const searchInitiatedRef = useRef(false)
	const availableDates = []
	const cuit = auth?.metadatos?.find(m => m.metadato.clave === 'CUIT')?.valor
	const handleSelectDate = date => {
		setSelectedDate(date)
		setShowCalendar(false)
	}

	const fetchDuties = async () => {
		if (!selectedDate) return
		const requestKey = `${moment(selectedDate).format('DD/MM/YYYY')}-${currentPage}`

		if (inFlightRequestKeyRef.current === requestKey) {
			return
		}
		inFlightRequestKeyRef.current = requestKey
		setLoading(true)
		try {
			const [err, { data } = {}] = await to(
				getDuties({
					fechaDesde: moment(selectedDate).format('DD/MM/YYYY'),
					pagina: currentPage,
					itemsPorPagina: 10,
					cuit:cuit
				})
			)

			if (err) throw new Error('Error en el fetch de roles')

			setResultsLst(Array.isArray(data?.items) ? data.items : [])
			setTotalPages(data?.totalPaginas || 1)
		} catch (err) {
			setResultsLst([])
			setTotalPages(1)
		} finally {
			if (inFlightRequestKeyRef.current === requestKey) {
				inFlightRequestKeyRef.current = null
			}
			setLoading(false)
			setSearchWasMade(true)
		}
	}

	useEffect(() => {
		if (!searchInitiatedRef.current) return
		fetchDuties()
	}, [currentPage])

	const handlePageChange = page => {
		setCurrentPage(page)
	}

	const handleFilters = () => {
		searchInitiatedRef.current = true
		if (currentPage === 1) {
			fetchDuties()
			return
		}

		setCurrentPage(1)
	}

	const downloadDutiesAsFileHandler = async (row, extension) => {
		const request = {
			id: row.id
		}
		try {
			const { data } = await downloadDutiesAsFile(request, extension)
			const type = extension === 'pdf' ? 'application/pdf' : 'application/vnd.ms-excel'
			const blob = new Blob([data], { type })
			const filename = `arancel_${new Date().getTime()}.${extension}`
			if (window.navigator && window.navigator.msSaveOrOpenBlob) {
				window.navigator.msSaveBlob(blob, filename)
			} else {
				var link = document.createElement('a')
				link.href = window.URL.createObjectURL(blob)
				link.download = filename
				link.click()
			}
		} catch (err) {}
	}

	const arancelesHeaders = [
		{ label: 'Fecha de vigencia', key: 'fechaVigencia', icon: <ArrowDouble /> },
		{ label: 'Clínica', key: 'clinica', icon: <ArrowDouble /> },
		{ label: 'Observaciones', key: 'observaciones', icon: <ArrowDouble /> },
		{
			label: 'Descargas',
			key: 'descargas',
			render: row => (
				<Container style={{ display: 'flex', flexDirection: 'row', gap: '8px', margin: '0px 0px' }}>
					<IconContainer onClick={() => downloadDutiesAsFileHandler(row, 'pdf')}>
						<Download color={theme.colors.brand.blueOmint} />
						<Text1
							color={theme.colors.brand.blueOmint}
							size={'14px'}
							style={{ textDecoration: 'underline', cursor: 'pointer' }}
						>
							PDF
						</Text1>
					</IconContainer>
					<IconContainer onClick={() => downloadDutiesAsFileHandler(row, 'xls')}>
						<Download color={theme.colors.brand.blueOmint} />
						<Text1
							color={theme.colors.brand.blueOmint}
							size={'14px'}
							style={{ textDecoration: 'underline', cursor: 'pointer' }}
						>
							XLS
						</Text1>
					</IconContainer>
				</Container>
			)
		}
	]

	return (
		<div style={{ width: '100%' }}>
			<Section gap="32px">
				<SectionHeader direction="row" align={'flex-start'} gap="12px">
					<SectionTitle mb="0px" mbDesktop="0px">
						Listado de Aranceles{' '}
					</SectionTitle>
				</SectionHeader>

				<Formik
					reinitialize
					onSubmit={values => {
						handleFilters()
					}}
				>
					{({ values }) => (
						<FormContainer
							direction="row"
							align="start"
							justify="start"
							margin="0"
							mb="0px"
							paddingMobile="0"
							maxWidth="100%"
						>
							<Container style={{ position: 'relative', width: isMobile ? '100%' : '362px' }}>
								<Input
									width={isMobile ? '100%' : '362px'}
									fullWidth={isMobile}
									placeholder="Selecciona una fecha"
									value={selectedDate ? selectedDate.toLocaleDateString('es-AR') : ''}
									onFocus={() => setShowCalendar(true)}
									readOnly
									icon={<Calendar />}
								/>
								{showCalendar && (
									<CalendarBlock style={{ position: 'absolute', zIndex: 10, top: '50px', left: 0 }}>
										<DatePicker
											selected={selectedDate}
											onChange={handleSelectDate}
											includeDates={availableDates.length ? availableDates : undefined}
											locale="es"
											dateFormat="dd/MM/yyyy"
											inline
										/>
									</CalendarBlock>
								)}
							</Container>
							<Button
								$variant={'primary'}
								disabled={!selectedDate || loading}
								label={`Consultar `}
								onClick={() => handleFilters()}
							/>{' '}
						</FormContainer>
					)}
				</Formik>
			</Section>
			{searchWasMade && (
				<Section>
					{isMobile ? (
						resultsLst.length > 0 ? (
							<ResultsList
								results={resultsLst}
								fields={arancelesHeaders}
								renderDownloads={row => (
									<Container
										style={{
											display: 'flex',
											flexDirection: 'row',
											gap: '8px',
											justifyContent: 'flex-start',
											margin: '0px 0px'
										}}
									>
										<IconContainer onClick={() => downloadDutiesAsFileHandler(row, 'pdf')}>
											<Download color={theme.colors.brand.blueOmint} />
											<Text1
												color={theme.colors.brand.blueOmint}
												size={'14px'}
												style={{ textDecoration: 'underline', cursor: 'pointer' }}
											>
												PDF
											</Text1>
										</IconContainer>
										<IconContainer onClick={() => downloadDutiesAsFileHandler(row, 'xls')}>
											<Download color={theme.colors.brand.blueOmint} />
											<Text1
												color={theme.colors.brand.blueOmint}
												size={'14px'}
												style={{ textDecoration: 'underline', cursor: 'pointer' }}
											>
												XLS
											</Text1>
										</IconContainer>
									</Container>
								)}
								renderField={(field, result) =>
									field.key === 'fechaVigencia' ? (
										<Text1 key={field.key} size={'16px'} color={theme.colors.text.primaryText}>
											<strong>{field.label}: </strong>
											{result[field.key]}
										</Text1>
									) : field.key === 'clinica' ? (
										<Text1
											key={field.key}
											size={'16px'}
											color={theme.colors.text.secondaryText}
											weight={400}
										>
											{result[field.key]}
										</Text1>
									) : field.key === 'observaciones' ? (
										<Text1
											key={field.key}
											size={'12px'}
											color={theme.colors.text.secondaryText}
											weight={400}
										>
											{result[field.key]}
										</Text1>
									) : null
								}
							/>
						) : (
							<EmptyState isSearch={true} />
						)
					) : searchWasMade ?  (
						<ResultsListDesk
							results={resultsLst}
							isSearch={true}
							searchWasMade={searchWasMade}						showResetButton={false}							handleDownloadArancel={downloadDutiesAsFileHandler}
						/>
					):null}
					{resultsLst?.length > 0 && (
						<Pagination
							totalPages={totalPages}
							currentPage={currentPage}
							onPageChange={handlePageChange}
						/>
					)}
				</Section>
			)}
		</div>
	)
}

const mapStateToProps = ({ patient, filterLaboratory, auth }) => ({
	filters: selectLabsFilters(filterLaboratory),
	filtersCount: selectLabsFiltersCount(filterLaboratory),
	patient,
	auth
})

export default connect(mapStateToProps, null)(Arancels)
